export default __webpack_public_path__ + "static/media/01.1a2dcea7.jpg";